type IsStoryblokEditorContextOptions = {
  /** Treat local development the same as Storyblok preview (e.g. editor-only UI). */
  includeDevelopment?: boolean;
};

export function isStoryblokEditorContext(options?: IsStoryblokEditorContextOptions): boolean {
  if (options?.includeDevelopment && process.env.NODE_ENV === 'development') {
    return true;
  }

  if (typeof window === 'undefined') {
    return false;
  }

  return new URLSearchParams(window.location.search).has('_storyblok');
}
